if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      connectedCallback() {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled) return;
        this.submitButton.setAttribute('disabled', true);

        const formData = new FormData(this.form);
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer) {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              console.error('Cart error:', parsedState.description);
              return;
            }
            if (cartDrawer) {
              cartDrawer.renderContents(parsedState);
            } else {
              window.location.href = window.routes.cart_url;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.removeAttribute('disabled');
          });
      }
    }
  );
}
